module.exports = __webpack_public_path__ + "img/slip_sample_2.bdb42a67.jpg";